import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CreatorService {

  constructor(
    private http: HttpClient
  ) { }

  getCurrentApplicableConnections(businessId: string, externalId: string) {

    console.log('Get current applicable connections ---->');
    console.log('Business ID: ' + '>>' + businessId + '<<');
    console.log('External ID: ', externalId);

    const callUrl = `${environment.api.baseUrl}/creators/current-applicable-connections/${businessId}/${externalId}`;

    console.log('callUrl: ' + '>>' + callUrl + '<<');

    // return this.http.get(`${environment.api.baseUrl}/creators/current-applicable-connections/${businessId}/${externalId}`);
    return this.http.get(callUrl);
  }
}


export enum TikTokValuesSourceEnum {
  TIKTOK_API = 'tiktok_api',
  TIK_API = 'tik_api',
  APIFY = 'apify'
}

export enum InstagramValuesSourceEnum {
  META_API = 'meta_api',
  APIFY = 'apify',
}

export enum YouTubeValuesSourceEnum {
  YOUTUBE_API = 'youtube_api',
  APIFY = 'apify',
}
